import { faGear as faGearDuo } from "@fortawesome/duotone-light-svg-icons/faGear";
import { faQuestionCircle as faQuestionCircleDuo } from "@fortawesome/duotone-light-svg-icons/faQuestionCircle";
import { faLinkedin } from "@fortawesome/free-brands-svg-icons/faLinkedin";
import { faCircleCheck as faCircleCheckDuo } from "@fortawesome/pro-duotone-svg-icons/faCircleCheck";
import { faCircleEllipsis as faCircleEllipsisDuo } from "@fortawesome/pro-duotone-svg-icons/faCircleEllipsis";
import { faCircleX as faCircleXDuo } from "@fortawesome/pro-duotone-svg-icons/faCircleX";
import { faTriangleExclamation as faTriangleExclamationDuo } from "@fortawesome/pro-duotone-svg-icons/faTriangleExclamation";

import { faAmbulance } from "@fortawesome/pro-light-svg-icons/faAmbulance";
import { faArrowDownLong } from "@fortawesome/pro-light-svg-icons/faArrowDownLong";
import { faArrowDownToLine } from "@fortawesome/pro-light-svg-icons/faArrowDownToLine";
import { faArrowLeftLong } from "@fortawesome/pro-light-svg-icons/faArrowLeftLong";
import { faArrowProgress } from "@fortawesome/pro-light-svg-icons/faArrowProgress";
import { faArrowRightLong } from "@fortawesome/pro-light-svg-icons/faArrowRightLong";
import { faArrowUpLong } from "@fortawesome/pro-light-svg-icons/faArrowUpLong";
import { faArrowUpRightFromSquare } from "@fortawesome/pro-light-svg-icons/faArrowUpRightFromSquare";
import { faAt } from "@fortawesome/pro-light-svg-icons/faAt";
import { faBaby } from "@fortawesome/pro-light-svg-icons/faBaby";
import { faBadgeDollar } from "@fortawesome/pro-light-svg-icons/faBadgeDollar";
import { faBallotCheck } from "@fortawesome/pro-light-svg-icons/faBallotCheck";
import { faBars } from "@fortawesome/pro-light-svg-icons/faBars";
import { faBaseballBatBall } from "@fortawesome/pro-light-svg-icons/faBaseballBatBall";
import { faBed } from "@fortawesome/pro-light-svg-icons/faBed";
import { faBicycle } from "@fortawesome/pro-light-svg-icons/faBicycle";
import { faBoltLightning } from "@fortawesome/pro-light-svg-icons/faBoltLightning";
import { faBook } from "@fortawesome/pro-light-svg-icons/faBook";
import { faBoxes } from "@fortawesome/pro-light-svg-icons/faBoxes";
import { faBoxTaped } from "@fortawesome/pro-light-svg-icons/faBoxTaped";
import { faBridgeSuspension } from "@fortawesome/pro-light-svg-icons/faBridgeSuspension";
import { faBriefcase } from "@fortawesome/pro-light-svg-icons/faBriefcase";
import { faBuilding } from "@fortawesome/pro-light-svg-icons/faBuilding";
import { faBuildingColumns } from "@fortawesome/pro-light-svg-icons/faBuildingColumns";
import { faBurgerFries } from "@fortawesome/pro-light-svg-icons/faBurgerFries";
import { faCalculator } from "@fortawesome/pro-light-svg-icons/faCalculator";
import { faCalendarDay } from "@fortawesome/pro-light-svg-icons/faCalendarDay";
import { faCameraCctv } from "@fortawesome/pro-light-svg-icons/faCameraCctv";
import { faCameraMovie } from "@fortawesome/pro-light-svg-icons/faCameraMovie";
import { faCancel } from "@fortawesome/pro-light-svg-icons/faCancel";
import { faCandyBar } from "@fortawesome/pro-light-svg-icons/faCandyBar";
import { faCar } from "@fortawesome/pro-light-svg-icons/faCar";
import { faCarBurst } from "@fortawesome/pro-light-svg-icons/faCarBurst";
import { faCarBus } from "@fortawesome/pro-light-svg-icons/faCarBus";
import { faCards } from "@fortawesome/pro-light-svg-icons/faCards";
import { faCarSideBolt } from "@fortawesome/pro-light-svg-icons/faCarSideBolt";
import { faCartShopping } from "@fortawesome/pro-light-svg-icons/faCartShopping";
import { faCarWash } from "@fortawesome/pro-light-svg-icons/faCarWash";
import { faCashRegister } from "@fortawesome/pro-light-svg-icons/faCashRegister";
import { faChalkboardUser } from "@fortawesome/pro-light-svg-icons/faChalkboardUser";
import { faChartLine } from "@fortawesome/pro-light-svg-icons/faChartLine";
import { faChartLineDown } from "@fortawesome/pro-light-svg-icons/faChartLineDown";
import { faChartMixedUpCircleDollar } from "@fortawesome/pro-light-svg-icons/faChartMixedUpCircleDollar";
import { faChartPie } from "@fortawesome/pro-light-svg-icons/faChartPie";
import { faChartSimple } from "@fortawesome/pro-light-svg-icons/faChartSimple";
import { faCheck } from "@fortawesome/pro-light-svg-icons/faCheck";
import { faCheckCircle } from "@fortawesome/pro-light-svg-icons/faCheckCircle";
import { faChevronDown } from "@fortawesome/pro-light-svg-icons/faChevronDown";
import { faChevronLeft } from "@fortawesome/pro-light-svg-icons/faChevronLeft";
import { faChevronRight } from "@fortawesome/pro-light-svg-icons/faChevronRight";
import { faChevronUp } from "@fortawesome/pro-light-svg-icons/faChevronUp";
import { faClipboard } from "@fortawesome/pro-light-svg-icons/faClipboard";
import { faClipboardListCheck } from "@fortawesome/pro-light-svg-icons/faClipboardListCheck";
import { faClock } from "@fortawesome/pro-light-svg-icons/faClock";
import { faComment } from "@fortawesome/pro-light-svg-icons/faComment";
import { faCommentQuestion } from "@fortawesome/pro-light-svg-icons/faCommentQuestion";
import { faCommentSmile } from "@fortawesome/pro-light-svg-icons/faCommentSmile";
import { faCommentSms } from "@fortawesome/pro-light-svg-icons/faCommentSms";
import { faCommentsQuestion } from "@fortawesome/pro-light-svg-icons/faCommentsQuestion";
import { faCouch } from "@fortawesome/pro-light-svg-icons/faCouch";
import { faCreditCard } from "@fortawesome/pro-light-svg-icons/faCreditCard";
import { faCubes } from "@fortawesome/pro-light-svg-icons/faCubes";
import { faDice } from "@fortawesome/pro-light-svg-icons/faDice";
import { faDogLeashed } from "@fortawesome/pro-light-svg-icons/faDogLeashed";
import { faDollarCircle } from "@fortawesome/pro-light-svg-icons/faDollarCircle";
import { faDollarSign } from "@fortawesome/pro-light-svg-icons/faDollarSign";
import { faDoorOpen } from "@fortawesome/pro-light-svg-icons/faDoorOpen";
import { faDumbbell } from "@fortawesome/pro-light-svg-icons/faDumbbell";
import { faEllipsis } from "@fortawesome/pro-light-svg-icons/faEllipsis";
import { faEllipsisVertical } from "@fortawesome/pro-light-svg-icons/faEllipsisVertical";
import { faEnvelopeOpenDollar } from "@fortawesome/pro-light-svg-icons/faEnvelopeOpenDollar";
import { faEquals } from "@fortawesome/pro-light-svg-icons/faEquals";
import { faEye } from "@fortawesome/pro-light-svg-icons/faEye";
import { faFaceLaughBeam } from "@fortawesome/pro-light-svg-icons/faFaceLaughBeam";
import { faFaceParty } from "@fortawesome/pro-light-svg-icons/faFaceParty";
import { faFaucetDrip } from "@fortawesome/pro-light-svg-icons/faFaucetDrip";
import { faFileInvoiceDollar } from "@fortawesome/pro-light-svg-icons/faFileInvoiceDollar";
import { faFileLines } from "@fortawesome/pro-light-svg-icons/faFileLines";
import { faFiles } from "@fortawesome/pro-light-svg-icons/faFiles";
import { faFlagUsa } from "@fortawesome/pro-light-svg-icons/faFlagUsa";
import { faFlowerTulip } from "@fortawesome/pro-light-svg-icons/faFlowerTulip";
import { faForkKnife } from "@fortawesome/pro-light-svg-icons/faForkKnife";
import { faGamepadModern } from "@fortawesome/pro-light-svg-icons/faGamepadModern";
import { faGasPump } from "@fortawesome/pro-light-svg-icons/faGasPump";
import { faGear } from "@fortawesome/pro-light-svg-icons/faGear";
import { faGift } from "@fortawesome/pro-light-svg-icons/faGift";
import { faGlassesRound } from "@fortawesome/pro-light-svg-icons/faGlassesRound";
import { faGlobe } from "@fortawesome/pro-light-svg-icons/faGlobe";
import { faGraduationCap } from "@fortawesome/pro-light-svg-icons/faGraduationCap";
import { faGrid2 } from "@fortawesome/pro-light-svg-icons/faGrid2";
import { faHandHoldingDollar } from "@fortawesome/pro-light-svg-icons/faHandHoldingDollar";
import { faHandHoldingHeart } from "@fortawesome/pro-light-svg-icons/faHandHoldingHeart";
import { faHandshakeAngle } from "@fortawesome/pro-light-svg-icons/faHandshakeAngle";
import { faHandWave } from "@fortawesome/pro-light-svg-icons/faHandWave";
import { faHouseChimney } from "@fortawesome/pro-light-svg-icons/faHouseChimney";
import { faHouseFire } from "@fortawesome/pro-light-svg-icons/faHouseFire";
import { faIdCard } from "@fortawesome/pro-light-svg-icons/faIdCard";
import { faImageSlash } from "@fortawesome/pro-light-svg-icons/faImageSlash";
import { faInfoCircle } from "@fortawesome/pro-light-svg-icons/faInfoCircle";
import { faIslandTropical } from "@fortawesome/pro-light-svg-icons/faIslandTropical";
import { faLandmark } from "@fortawesome/pro-light-svg-icons/faLandmark";
import { faLifeRing } from "@fortawesome/pro-light-svg-icons/faLifeRing";
import { faLightbulb } from "@fortawesome/pro-light-svg-icons/faLightbulb";
import { faLightbulbDollar } from "@fortawesome/pro-light-svg-icons/faLightbulbDollar";
import { faLightbulbOn } from "@fortawesome/pro-light-svg-icons/faLightbulbOn";
import { faLocationDot } from "@fortawesome/pro-light-svg-icons/faLocationDot";
import { faLockKeyhole } from "@fortawesome/pro-light-svg-icons/faLockKeyhole";
import { faMagnifyingGlass } from "@fortawesome/pro-light-svg-icons/faMagnifyingGlass";
import { faMagnifyingGlassDollar } from "@fortawesome/pro-light-svg-icons/faMagnifyingGlassDollar";
import { faMailboxFlagUp } from "@fortawesome/pro-light-svg-icons/faMailboxFlagUp";
import { faMegaphone } from "@fortawesome/pro-light-svg-icons/faMegaphone";
import { faMicroscope } from "@fortawesome/pro-light-svg-icons/faMicroscope";
import { faMinus } from "@fortawesome/pro-light-svg-icons/faMinus";
import { faMinusCircle } from "@fortawesome/pro-light-svg-icons/faMinusCircle";
import { faMobileNotch } from "@fortawesome/pro-light-svg-icons/faMobileNotch";
import { faMoneyBills } from "@fortawesome/pro-light-svg-icons/faMoneyBills";
import { faMoneyBillTransfer } from "@fortawesome/pro-light-svg-icons/faMoneyBillTransfer";
import { faMoneyBillWave } from "@fortawesome/pro-light-svg-icons/faMoneyBillWave";
import { faMoneyCheck } from "@fortawesome/pro-light-svg-icons/faMoneyCheck";
import { faMoneyCheckDollar } from "@fortawesome/pro-light-svg-icons/faMoneyCheckDollar";
import { faMoneyCheckDollarPen } from "@fortawesome/pro-light-svg-icons/faMoneyCheckDollarPen";
import { faMoneyFromBracket } from "@fortawesome/pro-light-svg-icons/faMoneyFromBracket";
import { faMugHot } from "@fortawesome/pro-light-svg-icons/faMugHot";
import { faMusic } from "@fortawesome/pro-light-svg-icons/faMusic";
import { faNewspaper } from "@fortawesome/pro-light-svg-icons/faNewspaper";
import { faPalette } from "@fortawesome/pro-light-svg-icons/faPalette";
import { faParking } from "@fortawesome/pro-light-svg-icons/faParking";
import { faPartyHorn } from "@fortawesome/pro-light-svg-icons/faPartyHorn";
import { faPawSimple } from "@fortawesome/pro-light-svg-icons/faPawSimple";
import { faPercent } from "@fortawesome/pro-light-svg-icons/faPercent";
import { faPersonWalkingLuggage } from "@fortawesome/pro-light-svg-icons/faPersonWalkingLuggage";
import { faPiggyBank } from "@fortawesome/pro-light-svg-icons/faPiggyBank";
import { faPlaneDeparture } from "@fortawesome/pro-light-svg-icons/faPlaneDeparture";
import { faPlus } from "@fortawesome/pro-light-svg-icons/faPlus";
import { faPlusCircle } from "@fortawesome/pro-light-svg-icons/faPlusCircle";
import { faPopcorn } from "@fortawesome/pro-light-svg-icons/faPopcorn";
import { faPowerOff } from "@fortawesome/pro-light-svg-icons/faPowerOff";
import { faPrescriptionBottle } from "@fortawesome/pro-light-svg-icons/faPrescriptionBottle";
import { faPrint } from "@fortawesome/pro-light-svg-icons/faPrint";
import { faQuestionCircle } from "@fortawesome/pro-light-svg-icons/faQuestionCircle";
import { faRectanglesMixed } from "@fortawesome/pro-light-svg-icons/faRectanglesMixed";
import { faRefresh } from "@fortawesome/pro-light-svg-icons/faRefresh";
import { faRocketLaunch } from "@fortawesome/pro-light-svg-icons/faRocketLaunch";
import { faRollerCoaster } from "@fortawesome/pro-light-svg-icons/faRollerCoaster";
import { faSackDollar } from "@fortawesome/pro-light-svg-icons/faSackDollar";
import { faScaleBalanced } from "@fortawesome/pro-light-svg-icons/faScaleBalanced";
import { faScissors } from "@fortawesome/pro-light-svg-icons/faScissors";
import { faScrewdriverWrench } from "@fortawesome/pro-light-svg-icons/faScrewdriverWrench";
import { faShieldCheck } from "@fortawesome/pro-light-svg-icons/faShieldCheck";
import { faShirt } from "@fortawesome/pro-light-svg-icons/faShirt";
import { faShoppingBag } from "@fortawesome/pro-light-svg-icons/faShoppingBag";
import { faShuffle } from "@fortawesome/pro-light-svg-icons/faShuffle";
import { faSmoking } from "@fortawesome/pro-light-svg-icons/faSmoking";
import { faSpa } from "@fortawesome/pro-light-svg-icons/faSpa";
import { faSpinner } from "@fortawesome/pro-light-svg-icons/faSpinner";
import { faSpinnerThird } from "@fortawesome/pro-light-svg-icons/faSpinnerThird";
import { faSplit } from "@fortawesome/pro-light-svg-icons/faSplit";
import { faSquareArrowUpRight } from "@fortawesome/pro-light-svg-icons/faSquareArrowUpRight";
import { faSquareList } from "@fortawesome/pro-light-svg-icons/faSquareList";
import { faStapler } from "@fortawesome/pro-light-svg-icons/faStapler";
import { faStars } from "@fortawesome/pro-light-svg-icons/faStars";
import { faStethoscope } from "@fortawesome/pro-light-svg-icons/faStethoscope";
import { faStore } from "@fortawesome/pro-light-svg-icons/faStore";
import { faSwimmingPool } from "@fortawesome/pro-light-svg-icons/faSwimmingPool";
import { faTags } from "@fortawesome/pro-light-svg-icons/faTags";
import { faTaxi } from "@fortawesome/pro-light-svg-icons/faTaxi";
import { faTeddyBear } from "@fortawesome/pro-light-svg-icons/faTeddyBear";
import { faTelevision } from "@fortawesome/pro-light-svg-icons/faTelevision";
import { faThumbsUp } from "@fortawesome/pro-light-svg-icons/faThumbsUp";
import { faToggleOn } from "@fortawesome/pro-light-svg-icons/faToggleOn";
import { faTooth } from "@fortawesome/pro-light-svg-icons/faTooth";
import { faTrain } from "@fortawesome/pro-light-svg-icons/faTrain";
import { faTrashCan } from "@fortawesome/pro-light-svg-icons/faTrashCan";
import { faTriangleExclamation } from "@fortawesome/pro-light-svg-icons/faTriangleExclamation";
import { faUserAstronaut } from "@fortawesome/pro-light-svg-icons/faUserAstronaut";
import { faUserChef } from "@fortawesome/pro-light-svg-icons/faUserChef";
import { faUserCircle } from "@fortawesome/pro-light-svg-icons/faUserCircle";
import { faUserDoctor } from "@fortawesome/pro-light-svg-icons/faUserDoctor";
import { faUserNurse } from "@fortawesome/pro-light-svg-icons/faUserNurse";
import { faUserSecret } from "@fortawesome/pro-light-svg-icons/faUserSecret";
import { faUsersRectangle } from "@fortawesome/pro-light-svg-icons/faUsersRectangle";
import { faUtensils } from "@fortawesome/pro-light-svg-icons/faUtensils";
import { faUtilityPole } from "@fortawesome/pro-light-svg-icons/faUtilityPole";
import { faWallet } from "@fortawesome/pro-light-svg-icons/faWallet";
import { faWashingMachine } from "@fortawesome/pro-light-svg-icons/faWashingMachine";
import { faWifi } from "@fortawesome/pro-light-svg-icons/faWifi";
import { faWineBottle } from "@fortawesome/pro-light-svg-icons/faWineBottle";
import { faXmark } from "@fortawesome/pro-light-svg-icons/faXmark";

import { faCaretRight as faCaretRightSolid } from "@fortawesome/pro-solid-svg-icons/faCaretRight";
import { faCheck as faCheckSolid } from "@fortawesome/pro-solid-svg-icons/faCheck";
import { faCreditCard as faCreditCardSolid } from "@fortawesome/pro-solid-svg-icons/faCreditCard";
import { faDollarCircle as faDollarCircleSolid } from "@fortawesome/pro-solid-svg-icons/faDollarCircle";
import { faFileInvoiceDollar as faFileInvoiceDollarSolid } from "@fortawesome/pro-solid-svg-icons/faFileInvoiceDollar";
import { faGrid2 as faGrid2Solid } from "@fortawesome/pro-solid-svg-icons/faGrid2";
import { faHouseChimney as faHouseChimneySolid } from "@fortawesome/pro-solid-svg-icons/faHouseChimney";
import { faMoneyBillTransfer as faMoneyBillTransferSolid } from "@fortawesome/pro-solid-svg-icons/faMoneyBillTransfer";
import { faMoneyCheckDollarPen as faMoneyCheckDollarPenSolid } from "@fortawesome/pro-solid-svg-icons/faMoneyCheckDollarPen";
import { faUserCircle as faUserCircleSolid } from "@fortawesome/pro-solid-svg-icons/faUserCircle";

export const ICON = {
  // dashboard
  piggyBank: faPiggyBank,
  dollar: faDollarSign,
  invoice: faFileInvoiceDollar,
  invoiceFill: faFileInvoiceDollarSolid,

  // nav
  house: faHouseChimney,
  houseFill: faHouseChimneySolid,
  transfer: faMoneyBillTransfer,
  transferFill: faMoneyBillTransferSolid,
  deposit: faMoneyCheckDollarPen,
  depositFill: faMoneyCheckDollarPenSolid,
  dashboard: faGrid2,
  dashboardFill: faGrid2Solid,
  transactions: faCreditCard,
  transactionsFill: faCreditCardSolid,
  income: faDollarCircle,
  incomeFill: faDollarCircleSolid,
  account: faUserCircle,
  accountFill: faUserCircleSolid,
  menu: faBars,

  // general
  imageSlash: faImageSlash,
  shoppingBag: faShoppingBag,
  questionCircle: faQuestionCircle,
  close: faXmark,
  caretRightSolid: faCaretRightSolid,
  warningTriangle: faTriangleExclamation,
  userSecret: faUserSecret,
  checkmark: faCheck,
  doorOpen: faDoorOpen,
  userCircle: faUserCircle,
  plusCircle: faPlusCircle,
  minusCircle: faMinusCircle,
  plus: faPlus,
  minus: faMinus,
  equals: faEquals,
  calendar: faCalendarDay,
  lock: faLockKeyhole,
  infoCircle: faInfoCircle,
  eye: faEye,
  spinner: faSpinnerThird,
  spinnerDots: faSpinner,
  paycheck: faMoneyCheck,
  chat: faComment,
  faceParty: faFaceParty,
  cancel: faCancel,
  email: faAt,
  checkCircle: faCheckCircle,
  files: faFiles,
  document: faFileLines,
  externalLink: faArrowUpRightFromSquare,
  download: faArrowDownToLine,
  openWindow: faSquareArrowUpRight,
  commentSmile: faCommentSmile,
  commentQuestion: faCommentQuestion,
  commentsQuestion: faCommentsQuestion,
  handWave: faHandWave,
  toggleOn: faToggleOn,
  powerOff: faPowerOff,
  chartSimple: faChartSimple,
  chartLine: faChartLine,
  chartLineDown: faChartLineDown,
  linkedin: faLinkedin,
  squareList: faSquareList,
  refresh: faRefresh,
  clipboard: faClipboard,
  ellipsis: faEllipsis,
  ellipsisVertical: faEllipsisVertical,
  lightbulbOn: faLightbulbOn,
  clipboardListCheck: faClipboardListCheck,
  moneyBillWave: faMoneyBillWave,
  envelopeOpenDollar: faEnvelopeOpenDollar,
  calculator: faCalculator,
  shuffle: faShuffle,
  wallet: faWallet,
  stethoscope: faStethoscope,
  cubes: faCubes,
  teddyBear: faTeddyBear,
  movieCamera: faCameraMovie,
  stars: faStars,
  faceLaughBeam: faFaceLaughBeam,
  dollarBadge: faBadgeDollar,
  astronaut: faUserAstronaut,
  rocketLaunch: faRocketLaunch,
  dice: faDice,
  clock: faClock,
  search: faMagnifyingGlass,
  usersRectangle: faUsersRectangle,
  arrowProgress: faArrowProgress,
  ballotCheck: faBallotCheck,
  thumbsUp: faThumbsUp,
  flagUsa: faFlagUsa,
  locationDot: faLocationDot,
  check: faMoneyCheckDollar,
  microscope: faMicroscope,
  dollars: faMoneyBills,
  gear: faGear,
  split: faSplit,
  pieChart: faChartPie,
  lightbulbDollar: faLightbulbDollar,

  // status
  statusPending: faCircleEllipsisDuo,
  statusWarning: faTriangleExclamationDuo,
  statusSuccess: faCircleCheckDuo,
  statusDanger: faCircleXDuo,

  // duo
  gearDuo: faGearDuo,
  questionCircleDuo: faQuestionCircleDuo,

  // solid
  checkmarkSolid: faCheckSolid,

  // home
  shield: faShieldCheck,
  commentSms: faCommentSms,
  briefcase: faBriefcase,

  // arrows
  arrowLeft: faArrowLeftLong,
  arrowRight: faArrowRightLong,
  arrowDown: faArrowDownLong,
  arrowUp: faArrowUpLong,
  chevronLeft: faChevronLeft,
  chevronRight: faChevronRight,
  chevronDown: faChevronDown,
  chevronUp: faChevronUp,

  // transaction categories
  loan: faHandHoldingDollar,
  bank: faBuildingColumns,
  popcorn: faPopcorn,
  food: faForkKnife,
  tools: faScrewdriverWrench,
  medical: faUserDoctor,
  spa: faSpa,
  services: faRectanglesMixed,
  landmark: faLandmark,
  car: faCar,
  plane: faPlaneDeparture,
  utilities: faUtilityPole,
  faucet: faFaucetDrip,
  phone: faMobileNotch,
  trash: faTrashCan,
  building: faBuilding,
  wifi: faWifi,
  electric: faBoltLightning,
  rental: faCarSideBolt,
  bed: faBed,
  luggage: faPersonWalkingLuggage,
  creditCard: faCreditCard,
  student: faGraduationCap,
  fee: faMagnifyingGlassDollar,
  atm: faMoneyFromBracket,
  globe: faGlobe,
  chartDown: faChartLineDown,
  percentage: faPercent,
  playingCards: faCards,
  music: faMusic,
  rollerCoaster: faRollerCoaster,
  videoGame: faGamepadModern,
  handshake: faHandshakeAngle,
  party: faPartyHorn,
  wine: faWineBottle,
  coffee: faMugHot,
  hamburger: faBurgerFries,
  grocery: faCartShopping,
  restaurant: faUserChef,
  candyBar: faCandyBar,
  book: faBook,
  shirt: faShirt,
  cashRegister: faCashRegister,
  store: faStore,
  discount: faTags,
  gadget: faTelevision,
  gift: faGift,
  stapler: faStapler,
  box: faBoxTaped,
  dogLeashed: faDogLeashed,
  baseball: faBaseballBatBall,
  cigarette: faSmoking,
  palette: faPalette,
  couch: faCouch,
  lightbulb: faLightbulb,
  security: faCameraCctv,
  pool: faSwimmingPool,
  tooth: faTooth,
  glasses: faGlassesRound,
  nurse: faUserNurse,
  pharmacy: faPrescriptionBottle,
  doctor: faUserDoctor,
  veteranarian: faPawSimple,
  ambulance: faAmbulance,
  dumbbell: faDumbbell,
  washer: faWashingMachine,
  scissors: faScissors,
  dollarChart: faChartMixedUpCircleDollar,
  carWash: faCarWash,
  baby: faBaby,
  scale: faScaleBalanced,
  chalkboard: faChalkboardUser,
  accident: faCarBurst,
  mailbox: faMailboxFlagUp,
  storage: faBoxes,
  charity: faHandHoldingHeart,
  idCard: faIdCard,
  moneyBag: faSackDollar,
  bicycle: faBicycle,
  gasoline: faGasPump,
  parking: faParking,
  bridge: faBridgeSuspension,
  carBus: faCarBus,
  train: faTrain,
  taxi: faTaxi,
  print: faPrint,
  megaphone: faMegaphone,
  houseFire: faHouseFire,
  lifeRing: faLifeRing,
  newspaper: faNewspaper,
  flowerTulip: faFlowerTulip,
  tropicalIsland: faIslandTropical,
  utensils: faUtensils,
};

export const ICON_SIZE = {
  xs: 12,
  sm: 18,
  md: 24,
  lg: 30,
  xl: 40,
};
